<template>
  <div class="bg-white pb-20">
    <div
      v-for="(item, index) in unsignedDocs"
      :key="item.id"
      class="border border-zt-dark-200"
      :class="{
        'documents--item__selected': item.id === docSelected
      }"
    >
      <zt-tooltip
        :active="item.locked && index > 0 && windowWidth >= 1024"
        position="right"
      >
        <template v-slot:body>
          <div class="tooltip-body">
            <p class="pb-2">
              {{ $t('message.documentComponent.tooltip.main.top') }}
              <br />
              {{
                $t(
                  `message.documentComponent.tooltip.main.${
                    index > 1 ? 'plural' : 'single'
                  }`,
                  { count: index }
                )
              }}
            </p>
            <p>
              {{ $t('message.documentComponent.tooltip.main.bottom') }}
            </p>
          </div>
        </template>
        <zt-list-item
          class="outline-none items-center"
          :class="{
            'documents--item__selected': item.id === docSelected,
            'documents--item': item.id !== docSelected,
            'opacity-75': item.locked
          }"
          @click="item.locked ? showAlert() : showDocument(item)"
        >
          <template>
            <div
              class="flex border-l-6 p-4"
              :class="[
                item.locked ? 'border-zt-dark-300' : 'border-zt-success'
              ]"
            >
              <div class="w-full leading-none text-left document--item-detail">
                <div class="text-zt-base truncate text-black mb-2">
                  {{ item.carpeta_nombre + '-' + item.tipo_nombre }}
                </div>
                <div
                  class="text-left text-zt-xs item--subtitle leading-none truncate mb-2"
                >
                  {{ item.nombre ? item.nombre : item.periodo }}
                </div>
                <zt-chip
                  square
                  outline
                  :class="[item.locked ? 'locked' : 'pending']"
                >
                  {{
                    item.locked
                      ? $t('message.documentComponent.unSignDocuments.bloqued')
                      : $t('message.LicensesHistoryComponent.statusPending')
                  }}
                </zt-chip>
              </div>
              <div
                class="documents--icon my-auto ml-auto order-last text-zt-xl text-black pr-2"
              >
                <zt-icon :name="item.locked ? 'lock-solid' : ''" />
              </div>
            </div>
          </template>
        </zt-list-item>
      </zt-tooltip>
    </div>
    <infinite-loading
      v-if="infiniteLoadingEnable"
      ref="infiniteLoading"
      spinner="spiral"
      @infinite="showMore"
    >
      <div class="noMoreResults" slot="no-more">
        {{ $t('message.documentComponent.noMoreResults') }}
      </div>
      <div class="noMoreResults" slot="no-results">
        {{ $t('message.documentComponent.noMoreResults') }}
      </div>
    </infinite-loading>
  </div>
</template>
<script>
import { isEmpty } from 'lodash'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'UnsignedDocs',
  components: {
    InfiniteLoading
  },
  props: [
    'docSelected',
    'showAlert',
    'unsignedDocs',
    'showDocument',
    'windowWidth'
  ],
  computed: {
    ...mapGetters('documents', ['getUnsignedDocsInbox']),
    ...mapState('documents', ['unSignedLastId']),
    isInboxDocumentActivated() {
      const actions = this.$store.state.actions
      return actions.some(action => action.id === '304')
    },
    infiniteLoadingEnable() {
      return (
        this.isInboxDocumentActivated &&
        this.unSignedLastId &&
        this.getUnsignedDocsInbox.length > 0
      )
    }
  },
  created() {
    if (!isEmpty(this.unsignedDocs) && this.windowWidth > 1024) {
      const firstDoc = this.unsignedDocs[0]
      return this.showDocument(firstDoc)
    }
  },
  methods: {
    ...mapActions('documents', ['setDocumentsUnSigned']),
    async showMore() {
      await this.setDocumentsUnSigned({ append: true })
      await this.$nextTick()
      if (this.$store.state.documents.unSignedLastId) {
        this.$refs.infiniteLoading.stateChanger.reset()
      }
    }
  }
}
</script>

<style scoped>
.outline-none {
  outline: none;
}

.documents--item:hover {
  background-color: #f5f5f5;
}

.documents--item__selected {
  background: #e0e0e0;
}
.document--item-detail {
  width: calc(100% - 42px);
}
.document--item-detail div div p:first-child {
  color: #2d2d2d;
}

.document--item-detail div div p:nth-child(2) {
  color: #707070;
}

.zt-chip {
  width: 65px;
  height: 24px !important;
  padding: 6px !important;
  display: flex;
  justify-content: center;
  font-size: 0.7rem !important;
  text-transform: uppercase;
  margin: 0 !important;
}

.zt-chip.pending {
  background-color: #e1f5fe !important;
  color: #017eec !important;
  border-color: #017eec !important;
}

.zt-chip.locked {
  background-color: #ebebeb !important;
  color: #575757 !important;
  border-color: #575757 !important;
}
</style>
